import {
  SHIPPING_PROVIDER_TEXT
} from '../constants/shipping-status'

const menuItemsProviderType = [
  {
    label: 'เลือกทั้งหมด',
    value: 'all',
  },
  ...Object.keys(SHIPPING_PROVIDER_TEXT).map((key) => ({
    label: SHIPPING_PROVIDER_TEXT?.[key] as string,
    value: key,
  })),
]

export const AllowShippingProviderLists = (merchant: any) => {
  const allowProviders = merchant.config?.providers ?? []

  //console.log('allowProviders', allowProviders)
  //console.log('menuItemsProviderType', menuItemsProviderType)

  return menuItemsProviderType.filter((item) => {
    return allowProviders.includes(item.value)
  })
}
